module.exports = __webpack_public_path__ + "static/img/777.9fb8971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/777.png
// module id = MrxT
// module chunks = 3